import React, { Fragment, useEffect } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
//Action creators
import { postLoginCredentials } from '@actions/account/accountActionCreators';
// Components
import Home from './Home';
// Constants
import { getRouteAndState } from './utils';

const HomeContainer = props => {
    const {
        environment: {
            stateCode,
            screenerConfigs: { leadPresent },
        },
    } = props;

    useEffect(() => {
        const handleBeforeUnload = () => {
            sessionStorage.clear();
        };
        window.addEventListener('beforeunload', handleBeforeUnload);
        return () => {
            window.removeEventListener('beforeunload', handleBeforeUnload);
        };
    }, []);

    const updatedPath = getRouteAndState(leadPresent, null, stateCode);
    const path = updatedPath.route;

    return (
        <Fragment>
            <main className="usa-layout-docs usa-section gi-main-section" id="keystone__page">
                <div className="grid-container gi-grid-container">
                    <div className="grid-row grid-gap gi-wrapper">
                        <div className="grid-col-12">
                            <div className="grid-row">
                                <div className="desktop:grid-col-12" id="main-content">
                                    <Home {...{ ...props, path }} />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </main>
        </Fragment>
    );
};
const mapStateToProps = state => ({
    environment: state.common.environment,
    authentication: state.authentication.failure,
});
const mapDispatchToProps = dispatch => ({
    actions: bindActionCreators(
        {
            postLoginCredentials,
        },
        dispatch,
    ),
});

export default connect(mapStateToProps, mapDispatchToProps)(HomeContainer);
